import { useEffect, useState } from 'react'
import { Modal } from './Modal'
import { FreeButton } from '../atom/FreeButton'
import { FreePlanModal } from '../FreePlanModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserType } from '../../utils/common'
import { usePostExperiencePlan } from '../../hooks/query/usePostExperiencePlan'

import classNames from 'classnames'
import useUserStore from '../../store/useUserStore'
import { useStore } from '../../store/useStore'
import { isMobile } from 'react-device-detect'

export const Footer = () => {
  // fixed bottom-0 left-0 right-0
  const { pathname } = useLocation()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()
  const { signOutModal, setSignOutModal } = useStore()
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const paymentFreePlan = () => {
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      navigate('/video-editor')
      return
    }

    experiencePlanMutate('', {
      onSuccess: (data) => {
        navigate('/video-editor')
      },
      onError: () => {},
    })
  }
  useEffect(() => {
    if (signOutModal) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [signOutModal])
  if (isMobile && (pathname === '/ai-studio' || pathname === '/ai'))
    return <></>
  if (pathname === '/ai-studio' || pathname.includes('/ai/create')) return <></>
  return (
    <>
      {' '}
      <div
        className={classNames('bg-[#141415]', {
          'mt-[20px]':
            pathname !== '/' &&
            pathname !== '/coupon-pack' &&
            pathname !== '/challenge' &&
            pathname !== '/ai',
        })}
      >
        <footer className="items-between mx-auto flex max-w-[1232px] flex-col justify-center gap-[8px] px-4 py-[20px]">
          <h6 className="text-[16px] font-bold text-[#FFFFFF]">
            ANGEL LEAGUE Inc.
          </h6>
          <div className="flex flex-col gap-[8px]">
            <div className="flex flex-col gap-[2px]">
              <p className="text-[12px] text-[#8F929B]">주식회사 엔젤리그</p>
              <p className="text-[12px] text-[#8F929B]">대표이사 : 오현석</p>

              <p className="text-[12px] text-[#8F929B]">
                사업자등록번호 : 705-87-01352 통신판매업신고번호 : 제
                2021-서울강남-03485호
              </p>
              <p className="text-[12px] text-[#8F929B]">
                사업장주소 : 서울특별시 강남구 선릉로 158길 7, 4층 (청담동)
              </p>
              <p className="text-[12px] text-[#8F929B]">
                02-6203-2021 support@capbox.kr
              </p>
            </div>
            <p className="text-[12px] text-[#8F929B]">
              <a
                href="https://solution.fastseller.shop/termofuse"
                target="_blank"
                rel="noreferrer"
              >
                서비스약관
              </a>{' '}
              <a
                href="https://www.solution.fastseller.shop/privacypolicy"
                target="_blank"
                rel="noreferrer"
              >
                개인정보처리방침
              </a>
              {' | '}
              <button
                onClick={() => {
                  setSignOutModal(true)
                }}
              >
                회원 탈퇴
              </button>
            </p>
            <p className="flex gap-2 text-[12px] text-[#8F929B]">
              <a
                className="text-white"
                href="https://blog.fastseller.shop/"
                target="_blank"
                rel="noreferrer"
              >
                패스트셀러
              </a>
            </p>
            <p className="text-[14px] text-[#5E6068]">
              Copyright © AngelLeague All rights reserved.
            </p>
          </div>
        </footer>
        {signOutModal && (
          <Modal isModal={signOutModal}>
            <div className="z-50 h-[184px] w-[400px] rounded-t-[20px] border-t bg-white p-[20px]">
              <div className="flex h-full flex-col items-center justify-center gap-[24px]">
                <p className="text-[18px] font-bold text-error">회원탈퇴</p>
                <div>
                  <p className="">
                    support@capbox.kr로 회원 탈퇴 요청 부탁드립니다.
                  </p>
                </div>
              </div>
            </div>
            <div className="flex h-[60px] w-[400px] items-center justify-center rounded-b-[20px] border-b border-main bg-main font-bold">
              <button
                className="w-[400px] text-white"
                onClick={() => {
                  setSignOutModal(false)
                }}
              >
                확인
              </button>
            </div>
          </Modal>
        )}{' '}
        {isFreePlanModal && (
          <FreePlanModal
            isFreePlanModal={isFreePlanModal}
            setFreePlanModal={SetFreePlanModal}
          />
        )}
      </div>
    </>
  )
}
